<template>
  <div class="max-w-7xl mx-auto pb-10 relative">

    <div
      class="space-y-6 transition-all duration-300 animate-fade-in"
      :class="{ 'blur-sm pointer-events-none opacity-50': showModal || showCommitteeModal }"
    >

      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 class="text-2xl font-bold text-slate-900 dark:text-white tracking-tight">Bandeja de Solicitudes</h1>
          <p class="text-slate-500 dark:text-slate-400 text-sm">Desembolso de créditos.</p>
        </div>
       <!--  <button
          @click="openCreate"
          class="flex items-center gap-2 px-5 py-2.5 bg-brand-600 hover:bg-brand-700 text-white font-bold rounded-xl shadow-lg shadow-brand-500/30 transition-all active:scale-95"
        >
          <Plus class="w-5 h-5" /> Nueva Solicitud
        </button> -->
      </div>

      <div class="bg-white dark:bg-slate-900 p-4 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm flex flex-col sm:flex-row gap-4">
        <div class="relative flex-1">
          <Search class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input
            v-model="searchTerm"
            type="text"
            placeholder="Buscar por cliente o folio..."
            class="w-full pl-10 pr-4 py-2 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500 transition-all"
          >
        </div>

        <!-- <select v-model="statusFilter" @change="loadData" class="px-4 py-2 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-sm focus:outline-none min-w-[200px] font-medium text-slate-700 dark:text-slate-300">
          <option value="ALL">Todos los Registros</option>
          <option value="PENDING">Pendientes de Aprobación</option>
          <option value="APPROVED">Aprobados (Listos p/Desembolso)</option>
          <option value="ACTIVE">Desembolsados (Activos)</option>
          <option value="REJECTED">Rechazados</option>
        </select> -->
      </div>

      <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left">
            <thead class="text-xs text-slate-500 uppercase bg-slate-50 dark:bg-slate-800/50 border-b border-slate-100 dark:border-slate-800">
              <tr>
                <th class="px-6 py-4 font-semibold">Folio / Cliente</th>
                <th class="px-6 py-4 font-semibold">Producto</th>
                <th class="px-6 py-4 font-semibold text-right">Monto</th>
                <th class="px-6 py-4 font-semibold text-center">Plazo</th>
                <th class="px-6 py-4 font-semibold">Estado</th>
                <th class="px-6 py-4 font-semibold text-right">Acciones</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-100 dark:divide-slate-800">

              <tr v-if="isLoading">
                <td colspan="6" class="px-6 py-12 text-center text-slate-500">
                  <Loader2 class="w-8 h-8 animate-spin mx-auto mb-3 text-brand-500" />
                  Cargando solicitudes...
                </td>
              </tr>

              <tr v-else-if="filteredList.length === 0">
                <td colspan="6" class="px-6 py-12 text-center text-slate-500">
                  <Briefcase class="w-8 h-8 mx-auto mb-3 opacity-20" />
                  No hay solicitudes de crédito que coincidan con los filtros.
                </td>
              </tr>

              <tr v-else v-for="item in filteredList" :key="item.id" class="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors group">

                <td class="px-6 py-4">
                  <div class="flex flex-col">
                    <span class="font-bold text-slate-900 dark:text-slate-100 flex items-center gap-2">
                      <User class="w-3.5 h-3.5 text-slate-400" />
                      {{ item.customer_name || 'Cliente Desconocido' }}
                    </span>
                    <p class="text-[10px] font-mono text-black mt-1  dark:text-slate-100"> CEDULA:{{ item.customer_doc }}</p>
                    <p class="text-[10px] font-mono text-black mt-1  dark:text-slate-100"> CODIGO:{{ item.customer_code }}</p>
                  </div>
                </td>

                <td class="px-6 py-4">
                   <p class="text-[10px] font-mono text-black mt-1  dark:text-slate-100"> EXP:{{ item.code }}</p>
                  <div class="text-sm text-slate-700  dark:text-slate-100 font-medium">{{ item.product_name || 'Crédito Estándar' }}</div>
                  <div class="text-[10px] text-slate-900">{{ item.rate }}% Anual</div>
                </td>

                <td class="px-6 py-4 text-right">
                  <div class="font-bold text-brand-600  dark:text-slate-100">${{ Number(item.amount).toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</div>
                  <div class="text-[10px] text-slate-400">Total: ${{ Number(item.total_amount).toLocaleString('en-US', { minimumFractionDigits: 2 }) }}</div>
                </td>

                <td class="px-6 py-4 text-center">
                  <div class="inline-flex flex-col items-center justify-center bg-slate-100 dark:bg-slate-800 px-3 py-1.5 rounded-lg border border-slate-200 dark:border-slate-700">
                    <span class="font-bold text-slate-700 dark:text-slate-300">{{ item.term }}</span>
                    <span class="text-[9px] uppercase font-bold text-slate-500">{{ getFrequencyName(item.condition_level) }}</span>
                  </div>
                </td>

                <td class="px-6 py-4">
                  <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border"
                    :class="getStatusClasses(item.status)">
                    <component :is="getStatusIcon(item.status)" class="w-3.5 h-3.5" />
                    {{ getStatusLabel(item.status) }}
                  </span>
                </td>

                <td class="px-6 py-4 text-right">
                  <div class="flex justify-end gap-2">
                    <button
                      @click="openCommittee(item)"
                      class="p-2 rounded-lg transition-colors group relative"
                      :class="item.status === 'PENDING' ? 'text-amber-500 hover:bg-amber-50 hover:text-amber-700' : 'text-slate-400 hover:bg-slate-100 hover:text-slate-700'"
                      :title="item.status === 'PENDING' ? 'Resolver en Comité' : 'Ver Expediente'"
                    >
                      <FileCheck class="w-6 h-6" />
                      <!-- <span v-if="item.status === 'PENDING'" class="absolute -top-1 -right-1 flex h-2 w-2">
                       <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                        <span class="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
                      </span> -->
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 text-xs text-slate-500 flex justify-between items-center">
          <span>Mostrando {{ filteredList.length }} solicitudes</span>
        </div>
      </div>
    </div>

    <LoanForm
      :show="showModal"
      @close="showModal = false"
      @saved="loadData"
    />

    <CommitteeApprovalModal
      :show="showCommitteeModal"
      :loanId="selectedLoanId"
      @close="showCommitteeModal = false"
      @resolved="loadData"
    />

  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { Search, Plus, FileCheck, User, Briefcase, Loader2, Clock, CheckCircle, PlayCircle, XCircle } from 'lucide-vue-next';
import apiClient from '@/api/client';
import { SecureStorage } from '@/utils/secureStorage';
import { useToast } from '@/composables/useToast';
import LoanForm from './Form.vue';
import CommitteeApprovalModal from './Form.vue';

const list = ref([]);
const isLoading = ref(true);
const searchTerm = ref('');
const statusFilter = ref('PENDING'); // Empezamos filtrando por pendientes
const showModal = ref(false);

// Estados para el Comité
const showCommitteeModal = ref(false);
const selectedLoanId = ref('');
const { showError } = useToast();

const loadData = async () => {
  isLoading.value = true;
  try {
    const user = SecureStorage.getItem('llevo_user');
    if (!user?.company) return;

    // MAGIA DE API: Enviamos el status dinámicamente. Si es 'ALL', no enviamos parámetro de estado.
    const statusQuery = 'APPROVED';//statusFilter.value === 'ALL' ? '' : `&status=${statusFilter.value}`;
    const res = await apiClient.get(`/loans?company_id=${user.company}&status=${statusQuery}`);

    list.value = Array.isArray(res.data) ? res.data : (res.data.data || []);
  } catch (e) {
    console.error(e);
    showError('Error cargando las solicitudes.');
  } finally {
    isLoading.value = false;
  }
};

onMounted(loadData);

const filteredList = computed(() => {
  let result = list.value;
  // Ya no filtramos el status aquí localmente porque la API ya nos devolvió lo filtrado

  if (searchTerm.value) {
    const term = searchTerm.value.toLowerCase();
    result = result.filter(i =>
      i.customer_name?.toLowerCase().includes(term) ||
      i.id?.toLowerCase().includes(term)
    );
  }
  return result;
});

const openCommittee = (item) => {
  selectedLoanId.value = item.id;
  showCommitteeModal.value = true;
};

const getFrequencyName = (level) => {
  const map = { 1: 'Días', 2: 'Semanas', 3: 'Quincenas', 4: 'Meses' };
  return map[Number(level)] || 'Cuotas';
};

const getStatusClasses = (status) => {
  const map = {
    'PENDING': 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-400',
    'APPROVED': 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/20 dark:text-blue-400',
    'ACTIVE': 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-400',
    'REJECTED': 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-400',
  };
  return map[status] || 'bg-slate-100 text-slate-600 border-slate-200';
};

const getStatusIcon = (status) => {
  const map = {
    'PENDING': Clock,
    'APPROVED': CheckCircle,
    'ACTIVE': PlayCircle,
    'REJECTED': XCircle
  };
  return map[status] || Clock;
};

const getStatusLabel = (status) => {
  const map = {
    'PENDING': 'Comité Pend.',
    'APPROVED': 'Aprobado',
    'ACTIVE': 'Desembolsado',
    'REJECTED': 'Rechazado'
  };
  return map[status] || 'Desconocido';
};

const openCreate = () => { showModal.value = true; };
</script>

<style scoped>
@keyframes fade-in {
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in { animation: fade-in 0.3s ease-out forwards; }
</style>